import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {SkeletonBlock} from './SkeletonBlock';

export const PlaceholderCategoryHeader: React.FC<{className?: string}> = ({
  className,
}) => {
  return (
    <Container className={className}>
      <SkeletonBlock $height={'16px'} $width={'90px'} />
      <Header>
        <SkeletonBlock $height={'32px'} $width={'250px'} />
        <Sorting>
          <Filter $height={'30px'} $width={'80px'} />
          <Filter $height={'30px'} $width={'80px'} />
        </Sorting>
      </Header>
      <Divider />
      <Filters>
        <Filter $height={'30px'} $width={'5%'} />
        <Filter $height={'30px'} $width={'5%'} />
        <Filter $height={'30px'} $width={'5%'} />
        <Filter $height={'30px'} $width={'5%'} />
        <Filter $height={'30px'} $width={'5%'} />
        <Filter $height={'30px'} $width={'15%'} />
        <Filter $height={'30px'} $width={'10%'} />
        <Filter $height={'30px'} $width={'5%'} />
        <Filter $height={'30px'} $width={'10%'} />
      </Filters>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 30px 0;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Sorting = styled.div`
  display: flex;
`;

const Divider = styled.div`
  border-bottom: 1px solid ${COLORS.Grey3};
`;

const Filters = styled.div`
  display: flex;
  margin-top: 20px;
`;

const Filter = styled(SkeletonBlock)`
  margin-right: 15px;
  :last-child {
    margin-right: 0;
  }
`;
